'use client';

import { c as _c } from "react/compiler-runtime";
import { toBigInt } from '@morpho-org/dapp-core';
import { formatters } from '@morpho-org/ui-v6/utils';
import { Separator } from '@repo/ui';
import { InfoHoverCardTrigger } from '@/components/common/InfoHoverCardTrigger';
import { SllBadge } from '@/components/common/SllBadge';
import { trackMetricTooltipOpenChange } from '@/lib/analytics/client/trackers/metric-tooltip';
import type { MarketHeroData } from './HeroMarket.mapper';
import { convertToFormattedUsd } from './HeroMarketSection.client';
interface MarketLiquidityBreakdownHoverCardProps {
  market: MarketHeroData;
}
export const MarketLiquidityBreakdownHoverCard = t0 => {
  const $ = _c(52);
  const {
    market
  } = t0;
  let formatAssetAmount;
  let liquidityUsd;
  let t1;
  if ($[0] !== market.loanAsset || $[1] !== market.state.totalLiquidity) {
    const totalLiquidity = toBigInt(market.state.totalLiquidity);
    liquidityUsd = convertToFormattedUsd(market.loanAsset, totalLiquidity);
    let t2;
    if ($[5] !== market.loanAsset.decimals || $[6] !== market.loanAsset.symbol) {
      t2 = value => formatters.short.digits(2).trailingZero(false).default("-").unit(market.loanAsset.symbol).of(value, market.loanAsset.decimals);
      $[5] = market.loanAsset.decimals;
      $[6] = market.loanAsset.symbol;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    formatAssetAmount = t2;
    t1 = formatAssetAmount(totalLiquidity);
    $[0] = market.loanAsset;
    $[1] = market.state.totalLiquidity;
    $[2] = formatAssetAmount;
    $[3] = liquidityUsd;
    $[4] = t1;
  } else {
    formatAssetAmount = $[2];
    liquidityUsd = $[3];
    t1 = $[4];
  }
  const formattedLiquidity = t1;
  let t2;
  if ($[8] !== formatAssetAmount || $[9] !== market.state.liquidityAssets) {
    const marketLiquidity = toBigInt(market.state.liquidityAssets);
    t2 = formatAssetAmount(marketLiquidity);
    $[8] = formatAssetAmount;
    $[9] = market.state.liquidityAssets;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const formattedMarketLiquidity = t2;
  let t3;
  if ($[11] !== formatAssetAmount || $[12] !== market.reallocatableLiquidity) {
    const reallocatableLiquidity = toBigInt(market.reallocatableLiquidity);
    t3 = formatAssetAmount(reallocatableLiquidity);
    $[11] = formatAssetAmount;
    $[12] = market.reallocatableLiquidity;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const formattedReallocatableLiquidity = t3;
  let t4;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-foreground text-sm leading-none">Total Liquidity</span>;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== formattedLiquidity) {
    t5 = <div className="px-sm gap-y-2xs flex min-h-8 flex-wrap items-center justify-between gap-x-4 py-[1px]">{t4}<span className="text-foreground text-sm leading-none">{formattedLiquidity}</span></div>;
    $[15] = formattedLiquidity;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="px-sm my-1.5"><Separator /></div>;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="text-2xs text-secondary-foreground leading-none">Market Liquidity</span>;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== formattedMarketLiquidity) {
    t8 = <div className="px-sm gap-y-2xs flex min-h-8 flex-wrap items-center justify-between gap-x-4 py-[1px]">{t7}<span className="text-2xs text-secondary-foreground leading-none">{formattedMarketLiquidity}</span></div>;
    $[19] = formattedMarketLiquidity;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="text-2xs text-secondary-foreground leading-none">Public Allocator Liquidity</span>;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== formattedReallocatableLiquidity) {
    t10 = <div className="px-sm gap-y-2xs flex min-h-8 flex-wrap items-center justify-between gap-x-4 py-[1px]">{t9}<span className="text-2xs text-secondary-foreground leading-none">{formattedReallocatableLiquidity}</span></div>;
    $[22] = formattedReallocatableLiquidity;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t5 || $[26] !== t8) {
    t11 = <div className="py-sm min-w-0">{t5}{t6}{t8}{t10}</div>;
    $[24] = t10;
    $[25] = t5;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  const hoverCardContent = t11;
  let t12;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="text-secondary-foreground text-xs" style={{
      whiteSpace: "nowrap"
    }}><span>Total Liquidity</span></span>;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== hoverCardContent) {
    t13 = <div className="flex flex-nowrap items-center gap-[6px]">{t12}<InfoHoverCardTrigger maxWidth="400px" onOpenChange={_temp}>{hoverCardContent}</InfoHoverCardTrigger></div>;
    $[29] = hoverCardContent;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const t14 = liquidityUsd ? `$${liquidityUsd.value}` : "-";
  let t15;
  if ($[31] !== t14) {
    t15 = <span className="text-title-sm">{t14}</span>;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  const t16 = liquidityUsd?.unit;
  let t17;
  if ($[33] !== t16) {
    t17 = <span className="text-title-sm text-muted-foreground">{t16}</span>;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t15 || $[36] !== t17) {
    t18 = <div className="flex items-center">{t15}{t17}</div>;
    $[35] = t15;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== formattedLiquidity) {
    t19 = <span className="text-foreground text-sm">{formattedLiquidity}</span>;
    $[38] = formattedLiquidity;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] !== market.chainId || $[41] !== market.marketId) {
    t20 = <SllBadge chainId={market.chainId} marketId={market.marketId} source="total_liquidity" />;
    $[40] = market.chainId;
    $[41] = market.marketId;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t19 || $[44] !== t20) {
    t21 = <div className="gap-xs flex items-center">{t19}{t20}</div>;
    $[43] = t19;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t18 || $[47] !== t21) {
    t22 = <div className="gap-xs flex flex-col">{t18}{t21}</div>;
    $[46] = t18;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t13 || $[50] !== t22) {
    t23 = <div className="gap-sm flex flex-[1px] flex-col" data-testid="market-hero-total-liquidity">{t13}{t22}</div>;
    $[49] = t13;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  return t23;
};
function _temp(isOpen) {
  return trackMetricTooltipOpenChange(isOpen, {
    page: "market",
    metric: "total_liquidity"
  });
}